import { Component, inject } from "@angular/core";
import { Observable } from "rxjs";
import { SyncModel } from "../../../shared/offline";
import { CachedFile, SyncAction } from "../../../shared/types";
import { ExposedAppEvent } from "@intocare-medapp/events/event.service.interface";

@Component({
	selector: "ic-sync-actions-overview",
	templateUrl: "./sync-actions-overview.component.html",
	styleUrls: ["./sync-actions-overview.component.scss"],
	standalone: false,
})
export class SyncActionsOverviewComponent {
	private readonly sync = inject(SyncModel);

	actions$: Observable<(SyncAction | CachedFile | ExposedAppEvent)[]> = this.sync.actions$;
}
